<div *ngIf="!loading" class="container">
  <div class="title mb-3">
      <h4>Listado de Estudiantes</h4>
      <button (click)="disableAllStudents()" class="btn btn-danger btn-sm ms-2">
        Deshabilitar Todos
    </button>
    <button type="button" class="btn btn-primary" routerLink="/addstudent">Agregar Estudiante</button>
  </div>
  
  <div class="search-bar">
      <input type="text" placeholder="Buscar por nombre, apellido o CI" (input)="onSearch($event)" class="form-control">
  </div>

  <table *ngIf="filteredStudents.length > 0" class="table table-hover">
      <thead>
        <tr>
          <th scope="col">Nombre</th>
          <th scope="col">Apellidos</th>
          <th scope="col">CI</th>
          <th scope="col">Email</th>
          <th scope="col">Password</th>
          <th scope="col">Estado</th>
          <th scope="col">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of filteredStudents; let i = index" class="table-active">
          <td>{{ item.name }}</td>
          <td>{{ item.lastname }}</td>
          <td>{{ item.ci }}</td>
          <td>{{ item.username }}</td>
          <td>
            <input [type]="passwordVisible[i] ? 'text' : 'password'" [value]="item.password" class="form-control" readonly>
            <button type="button" (click)="togglePasswordVisibility(i)" class="btn btn-link">
              <!--<i [class]="passwordVisible[i] ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>ver-->
              <i class="bi bi-eye">ver</i>
            </button>
          </td>
          <td>{{ item.status === 1 ? 'Habilitado' : 'Deshabilitado' }}</td>
          <td>
              <button (click)="updateStudentStatus(item.id!, item.status)" type="button" class="btn btn-warning btn-sm">Cambiar estado</button>
              <button routerLink="/editstudent/{{item.id}}" type="button" class="btn btn-info btn-sm ms-2">Edit</button>
              <button (click)="deleteStudent(item.id!)" type="button" class="btn btn-secondary btn-sm ms-2">Delete</button>
          </td>
        </tr>
      </tbody>
    </table>
    <h5 *ngIf="filteredStudents.length == 0">No hay estudiantes para mostrar</h5>
</div>
